var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdministrative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M17.9,8.2V7.4h-0.4c0-0.2-0.1-0.3-0.2-0.5 l0.3-0.3l-0.5-0.5l-0.3,0.3c-0.1-0.1-0.3-0.2-0.5-0.2V5.7h-0.8v0.4c-0.2,0-0.3,0.1-0.5,0.2L14.7,6l-0.5,0.5l0.3,0.3 c-0.1,0.1-0.2,0.3-0.2,0.5h-0.4v0.8h0.4c0,0.2,0.1,0.3,0.2,0.5L14.1,9l0.5,0.5L15,9.2c0.1,0.1,0.3,0.2,0.5,0.2v0.4h0.8V9.4 c0.2,0,0.3-0.1,0.5-0.2l0.3,0.3L17.6,9l-0.3-0.3c0.1-0.1,0.2-0.3,0.2-0.5H17.9z M15.9,8.6c-0.5,0-0.8-0.4-0.8-0.8 c0-0.5,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8C16.7,8.3,16.3,8.6,15.9,8.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M5.3,5.9L5.3,5.9C5.1,6,5,6.3,5.1,6.6 c0,0.2,0.1,0.3,0.3,0.4c0.1,1,1,1.9,2,1.9s1.9-0.9,2.1-2c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.3,0-0.5-0.2-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.6,4.7c0-1.1-0.8-1.4-1.1-1.4 c-0.1-0.2-0.4-0.5-1-0.6c-1.4,0-2.1,1-2.3,1.6C5,5,5.4,6.7,5.4,6.7s0.1-0.9,0.1-1.2c0-0.5,0.7-0.6,1.8-0.7c0.8-0.1,1-0.4,1.1-0.5 c0,0.1,0,0.3,0.4,0.5C9,5,9.2,5.1,9.2,5.3c0,0.3,0.1,1.2,0.1,1.2S9.6,5.6,9.6,4.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.6,17.3H7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.4,9.1l3,0.9c0.3,0.1,0.6,0.3,0.8,0.6 c0.2,0.4,0.4,0.9,0.5,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M7.3,17.3H2.1v-3.9c0-1.5,0.2-2.3,0.5-2.8 c0.2-0.3,0.5-0.5,0.8-0.6l3-0.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "7.9,13.9 7.4,11.4 7.8,10.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "6.8,10.8 7.1,11.4 6.8,13.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.3,9.5L8.2,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M6.5,8.6l-0.1,1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M6.5,11.3l0.8-1.1c-0.9-0.1-1.1-1-1.1-1l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.5,9.2L8.5,9.2c-0.1-0.1-0.2,0.9-1.2,1 l0.9,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.5,12.1v2.5 C10.5,14.7,10.5,12.4,10.5,12.1L10.5,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.5,15.7v1.8 C10.5,17.5,10.5,15.9,10.5,15.7L10.5,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M4.1,12.1v5.1C4.1,17.3,4.1,12.6,4.1,12.1 L4.1,12.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "6.3,9.3 7.1,16.7 5.3,13.1 5.8,12.5  4.8,11.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "8.4,9.2 7.6,16.6 9.3,12.8 8.8,12.2  9.8,11.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M17.2,11c0,0,0.2,0.1,0.4-0.3 c0,0,0.4-0.6,0.8-0.2c0,0-0.3,1.3-1.3,1.6c0,0-0.8,0.1-1.6,0c0,0-0.1,0-0.2,0.1l-0.9-0.8h0.1c0,0,0.3-1,1.4-0.6 c0,0,0.3,0.2,0.9,0.2c0.7,0,0.4,0.5,0.1,0.5s-1,0.1-1,0.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "14.3,11.1 15.6,12.4 15.3,12.7  14,11.4  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14,11.4c-0.1-0.1-0.2-0.1-0.3,0l0,0l-2.9,3 c-0.4,0.4-0.4,1.2,0,1.6l0.1,0.1c0.4,0.4,1.2,0.4,1.6,0l2.9-3c0.1-0.1,0.1-0.1,0.1-0.2C15,12.3,14.5,11.8,14,11.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrative);
export default __webpack_public_path__ + "static/media/administrative.28f2e912999e8237045972c03c82af48.svg";
export { ForwardRef as ReactComponent };